import { render, staticRenderFns } from "./SustainabilityImpact_.vue?vue&type=template&id=af75ecaa&scoped=true&"
import script from "./SustainabilityImpact_.vue?vue&type=script&lang=ts&"
export * from "./SustainabilityImpact_.vue?vue&type=script&lang=ts&"
import style0 from "./SustainabilityImpact_.vue?vue&type=style&index=0&id=af75ecaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af75ecaa",
  null
  
)

export default component.exports